import { Box, Grid, Typography } from "@mui/material"
import { DlspTable } from "./DlspTable"
import { safeFormatDate } from "../../../utils/utilityFunctions"

export function DesktopAssessmentDetails({inspectedBy, inspectionDate, desktopChecklist}) {

    const leftTableRows = []
    leftTableRows.push({label: 'GIS Check Complete',                       text: desktopChecklist?.gisCheckComplete                    })
    leftTableRows.push({label: 'GIS Check Comments',                       text: desktopChecklist?.gisCheckComments                    })
    leftTableRows.push({label: 'Nearest Network Pole or Pillar',           text: desktopChecklist?.networkPoleOrPillar                 })
    leftTableRows.push({label: 'Google Maps Check Complete',               text: desktopChecklist?.googleMapsCheckComplete             })
    leftTableRows.push({label: 'Google Maps Check Comments',               text: desktopChecklist?.googleMapsCheckComments             })
    leftTableRows.push({label: 'Decommissioning Records Check Complete',   text: desktopChecklist?.decommissioningRecordsCheckComplete })
    leftTableRows.push({label: 'Decommissioning Records Check Comments',   text: desktopChecklist?.decommissioningRecordsCheckComments })
    leftTableRows.push({label: 'General Comments',                         text: desktopChecklist?.generalComments                     })
    leftTableRows.push({label: 'Priority QA / Too Hard',                   text: desktopChecklist?.tooHard                             ? 'Yes' : 'No'})
    

    const rightTableRows = []
    rightTableRows.push({label: 'Status of Service Line',  text: desktopChecklist?.statusOfServiceLine })
    rightTableRows.push({label: 'Visibility of Fuses',     text: desktopChecklist?.visibilityOfFuses   })
    rightTableRows.push({label: 'Location of Fuses',       text: desktopChecklist?.locationOfFuses     })
    rightTableRows.push({label: 'Status of Fuses',         text: desktopChecklist?.statusOfFuses       })

    return (
        <Box sx={{my: 2}}>
        {
            (!inspectedBy || !inspectionDate || !desktopChecklist)
            ?
            <></>
            :
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="body2"><strong>{inspectedBy}</strong></Typography>
                    <Typography variant="body2"><strong>{safeFormatDate(inspectionDate, 'd MMMM yyyy HH:mm a')}</strong></Typography>

                </Grid>
                <Grid item md={6}>
                    <DlspTable rows={leftTableRows} skipHeader={true} />
                </Grid>
                <Grid item md={6}>
                    <DlspTable rows={rightTableRows} skipHeader={true} />
                </Grid>
            </Grid>
        }
        </Box>
    )
}